import { Box, Flex, Stack, Center } from '@chakra-ui/react'
import React from 'react'
import { AppFooter } from '../../components/AppFooter'
import { AppHeader } from '../../components/AppHeader'
import SubNavigation from '../../components/SubNavigation'
import { useAuth, useClientRect } from '../../hooks'
import { ApexMenu } from '../ApexMenu'
import { LayoutContext } from '../contexts/layout/LayoutContext'
import apexLogo from './apex-logo-reverse.svg'

export interface Props {
  includeHeader?: boolean
  children: JSX.Element | JSX.Element[]
  includeSubNavigation: boolean
  fetchLogout: () => void
  showAppContent: boolean
}

const Layout = ({
  includeHeader,
  children,
  includeSubNavigation,
  fetchLogout,
  showAppContent,
}: Props) => {
  const [headerRect, headerRef] = useClientRect()
  const [footerRect, footerRef] = useClientRect()
  const headerHeight = headerRect?.height || 0
  const footerHeight = footerRect?.height || 0

  return (
    <Stack height="100vh" className="layout-container" spacing={0}>
      <Box zIndex="sticky" ref={headerRef} key={`header-${showAppContent}`}>
        {includeHeader ? (
          <>
            {showAppContent ? (
              <>
                <AppHeader title="Account Transfers" />
                <ApexMenu handleSignout={fetchLogout} />
              </>
            ) : (
              <Box background="blue.700" height="58px">
                <Center>
                  <Box pt="8px">
                    <img src={apexLogo} alt="Apex Fintech Solutions" />
                  </Box>
                </Center>
              </Box>
            )}
            {showAppContent && includeSubNavigation && <SubNavigation />}
          </>
        ) : (
          <AppHeader title="&nbsp;" />
        )}
      </Box>
      <LayoutContext.Provider
        value={{
          headerHeight,
          footerHeight,
        }}
      >
        <Flex
          flexDirection="column"
          flexGrow={1}
          height={`calc(100vh - ${headerHeight + footerHeight}px)`}
        >
          {children}
        </Flex>
      </LayoutContext.Provider>
      <Box zIndex="sticky" ref={footerRef}>
        <AppFooter />
      </Box>
    </Stack>
  )
}

export default Layout
